/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Product options
document.querySelectorAll('.product-option').forEach(($option) => {
    $option.addEventListener('change', () => {
        const $form = $option.closest('form[action="/cart/add"]')

        const selectedOptions = []

        $form.querySelectorAll('.product-option').forEach(($option) => {
            if ($option.type === 'radio') {
                if ($option.checked) {
                    selectedOptions.push($option.value)
                }
            } else {
                selectedOptions.push($option.value)
            }
        })

        const selectedVariant = JSON.parse($form.dataset.variants).find(
            (variant) => JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
        )

        const $addToCartBtn = $form.querySelector('.btn-atc')
        const $buyItNowBtn = $form.querySelector('.btn-buy-it-now')

        if (selectedVariant) {
            // console.log(selectedVariant);

            $form.querySelector('select[name="id"]').value = selectedVariant.id

            if (selectedVariant.available) {
                $addToCartBtn.disabled = false
                
                $addToCartBtn.querySelector('span').textContent = $addToCartBtn.dataset.textAddToCart
            } else {
                $addToCartBtn.disabled = true
                
                $addToCartBtn.querySelector('span').textContent = $addToCartBtn.dataset.textSoldOut
            }

            const productPriceContainer = $form.querySelector('.product-price-container')

            productPriceContainer.querySelector('.product-price-final')
                .textContent = window.formatMoney(selectedVariant.price)

            if (selectedVariant.compare_at_price) {
                productPriceContainer.querySelector('.product-price-compare')
                    .textContent = window.formatMoney(selectedVariant.compare_at_price)
                productPriceContainer.querySelector('.product-price-compare')
                    .classList.remove('d-none')
            } else {
                productPriceContainer.querySelector('.product-price-compare')
                    .classList.add('d-none')
            }

            window.history.replaceState({}, '', `${$form.dataset.productUrl}?variant=${selectedVariant.id}`)

            if (selectedVariant.featured_media) {
                // bootstrap.Carousel.getInstance($form.closest('.product').querySelector('.product-carousel'))
                //     .to(selectedVariant.featured_media.position - 1)
                const event = new CustomEvent('slideProductImageGallery', { detail: selectedVariant.featured_media.position - 1 })
                window.dispatchEvent(event)
            }
        } else {
            $addToCartBtn.disabled = true
            $buyItNowBtn.disabled = true
            $addToCartBtn.querySelector('span').textContent = $addToCartBtn.dataset.textUnavailable
            window.history.replaceState({}, '', window.product.url)
        }
    })
})

// Product Carousel - Full Screen Gallery with PhotoSwipe
// https://photoswipe.com/v5/docs/getting-started/
// const initProductCarouselSwipe = () => {
//     document.querySelectorAll('.product .product-carousel').forEach(($carousel) => {
//         const lightbox = new PhotoSwipeLightbox({
//             gallery: $carousel,
//             children: 'a',
//             pswpModule: './photoswipe.esm.min.js'
//         })
//         lightbox.init()
//     })
// }
// initProductCarouselSwipe()

// Product image gallery with SplideJS
const initProductImageGallery = () => {
    const mainSplideElem = document.querySelector('.product .main-splide')
    const thumbsSplideElem = document.querySelector('.product .thumbs-splide')

    if (!mainSplideElem) {
        return
    }

    const mainSplide = new Splide(mainSplideElem, {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: false
    })

    const thumbsSplide = new Splide(thumbsSplideElem, {
        type: 'loop',
        gap: 12,
        rewind: true,
        arrows: true,
        pagination: false,
        perPage: 5,
        focus: 'center',
        isNavigation: true,
        breakpoints: {
            575: {
                perPage: 3,
                padding: { left: '2rem', right: '2rem' }
            }
        }
    })

    window.addEventListener('slideProductImageGallery', (e) => {
        mainSplide.go(e.detail)
    }, false)

    mainSplide.sync(thumbsSplide)
    mainSplide.mount()
    thumbsSplide.mount()
}
initProductImageGallery()

// Product Carousel - Sticky position on scroll (only in desktop)
const initProductCarouselSitckyPos = () => {
    document.querySelectorAll('.product-carousel.sticky-carousel').forEach(($carousel) => {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 20) {
                const headerHeight = document.querySelector('#shopify-section-header.sticky-top').clientHeight || 0
                $carousel.style.position = 'sticky'
                $carousel.style.top = `${headerHeight + 20}px`
            }
        })
    })
}
initProductCarouselSitckyPos()

// Delivery Info
const initDeliveryInfo = () => {
    document.querySelectorAll('.product-delivery-info').forEach(($el) => {
        const minDays = Number($el.dataset.minDays)
        const maxDays = Number($el.dataset.maxDays)

        const minDaysText = dayjs().locale('es-mx').add(minDays, 'day').format('dddd, MMM D')
        const maxDaysText = dayjs().locale('es-mx').add(maxDays, 'day').format('dddd, MMM D')

        $el.querySelector('span').insertAdjacentHTML('beforeend', `
            <b>${minDaysText}</b>
                - 
            <b>${maxDaysText}</b>
        `)
    })
}
initDeliveryInfo()

/*
    Product FBT - Set Total Price
*/
const productFbtSetTotalPrice = () => {
    let totalPrice = 0

    document.querySelectorAll('#product-fbt .form-check-input').forEach(($checkbox) => {
        if ($checkbox.checked) {
            const $select = $checkbox.closest('.product-list-item').querySelector('select[name="id"]')
            const variantPrice = Number($select.options[$select.selectedIndex].dataset.variantPrice)
            totalPrice += variantPrice
        }
    })

    document.querySelector('#product-fbt-total-price').textContent = window.formatMoney(totalPrice)

    if (totalPrice === 0) {
        document.querySelector('#btn-fbt-atc').disabled = true
    } else {
        document.querySelector('#btn-fbt-atc').disabled = false
    }
}

/*
    Product FBT - Handle variant change
*/
const productFbtVariantChange = () => {
    document.querySelectorAll('#product-fbt select[name="id"]').forEach(($select) => {
        $select.addEventListener('change', (e) => {
            productFbtSetTotalPrice()
        })
    })
}
productFbtVariantChange()

/*
    Product FBT - Handle checkbox (select product)
*/
const productFbtHandleCheckbox = () => {
    document.querySelectorAll('#product-fbt .form-check-input').forEach(($checkbox) => {
        const $imgWrapper = $checkbox.closest('.product-list-item').querySelector('.img-wrapper')

        $checkbox.addEventListener('change', (e) => {
            if ($checkbox.checked) {
                $imgWrapper.style.opacity = '1'
            } else {
                $imgWrapper.style.opacity = '0.25'
            }
            productFbtSetTotalPrice()
        })
    })
}
productFbtHandleCheckbox()

/*
    Product FBT - ATC button
*/
const productFbtAtcBtn = async () => {
    const $btn = document.querySelector('#btn-fbt-atc')

    $btn?.addEventListener('click', async (e) => {
        $btn.style.width = $btn.clientWidth + 2 + 'px'
        $btn.innerHTML = `
            <div 
                class="spinner-border spinner-border-sm" 
                role="status"
                style="width: 1rem; height: 1rem">
                <span class="visually-hidden">Loading...</span>
            </div>
        `

        const items = []

        document.querySelectorAll('#product-fbt select[name="id"]').forEach(($select) => {
            if ($select.closest('.product-list-item').querySelector('.form-check-input').checked) {
                items.push({
                    id: Number($select.value),
                    quantity: 1
                })
            }
        })

        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: items
            })
        })

        $btn.innerHTML = $btn.dataset.textAddSelected

        window.loadOffcanvasCart()
    })
}
productFbtAtcBtn()

// Product list item - Handle variant change
window.onChangeProductListItemVariant = (e) => {
    const variantImageId = e.target.options[e.target.selectedIndex].dataset.variantImageId

    if (variantImageId) {
        const $carousel = e.target.closest('.product-list-item').querySelector('.carousel')

        if ($carousel) {
            let carouselItemIndex = 0

            $carousel.querySelectorAll('.carousel-item').forEach((el, index) => {
                if (el.dataset.imageId === variantImageId) {
                    carouselItemIndex = index
                }
            })

            const carousel = bootstrap.Carousel.getOrCreateInstance($carousel)
            carousel.to(carouselItemIndex)
        }
    }
}

// Faux Live Visitors
document.querySelectorAll('[data-faux-live-visitors]').forEach(el => {
    const range = { min: 50, max: 100 }
    const delta = range.max - range.min

    el.textContent = Math.round(range.min + Math.random() * delta)

    setInterval(() => {
        el.textContent = Math.round(range.min + Math.random() * delta)
    }, 5000)
})
